import {
  type ClientOptions,
  FeatureGateEnvironment,
  type OptionsWithDefaults,
  PerimeterType,
} from '@atlaskit/feature-gate-js-client';

import { getConfig, getPlatformEnvironment } from '@townsquare/config';

export const featureGatesOptions: OptionsWithDefaults<ClientOptions> = {
  targetApp: 'atlas_web', // https://hello.atlassian.net/wiki/spaces/MEASURE/pages/2955970231/How-to+Use+TargetApps+in+Statsig
  apiKey: getConfig().featureFlagApiKey,
  environment: getPlatformEnvironment() === 'prod' ? FeatureGateEnvironment.Production : FeatureGateEnvironment.Staging,
  perimeter: PerimeterType.COMMERCIAL,
};
